// // import React, { useState, useEffect } from 'react';
// // import axios from 'axios';
// // import { FaDownload, FaSpinner, FaEye, FaEyeSlash } from 'react-icons/fa';
// // import { useUser } from '../UserContext';

// // // Years data outside component to avoid re-creation
// // const YEARS = [
// //   { id: '1', name: '1st Year' },
// //   { id: '2', name: '2nd Year' },
// //   { id: '3', name: '3rd Year' },
// //   { id: '4', name: '4th Year' },
// // ];

// // const TeacherReport = () => {
// //   const { user } = useUser();
// //   const apiUrl = (process.env.REACT_APP_API_URL || 'http://localhost:5001').trim();

// //   // Form state
// //   const [studentName, setStudentName] = useState('');
// //   const [username, setUsername] = useState('');
// //   const [selectedYear, setSelectedYear] = useState('');
// //   const [status, setStatus] = useState('');
// //   const [fromDate, setFromDate] = useState('');
// //   const [toDate, setToDate] = useState('');
// //   const [courseName, setCourseName] = useState('');

// //   // Data state
// //   const [students, setStudents] = useState([]);
// //   const [reports, setReports] = useState([]);
// //   const [selectedPdf, setSelectedPdf] = useState(null);
// //   const [pdfUrls, setPdfUrls] = useState({});

// //   // UI state
// //   const [loading, setLoading] = useState(false);
// //   const [loadingPdf, setLoadingPdf] = useState(false);
// //   const [error, setError] = useState(null);
// //   const [showNameSuggestions, setShowNameSuggestions] = useState(false);
// //   const [showUsernameSuggestions, setShowUsernameSuggestions] = useState(false);
// //   const [showCourseSuggestions, setShowCourseSuggestions] = useState(false);
// //   const [allStudents, setAllStudents] = useState([]);
// //   const [uniqueCourses, setUniqueCourses] = useState([]);
// //   const [nameSuggestionIndex, setNameSuggestionIndex] = useState(-1);
// //   const [usernameSuggestionIndex, setUsernameSuggestionIndex] = useState(-1);
// //   const [courseSuggestionIndex, setCourseSuggestionIndex] = useState(-1);

// //   // Fetch all students for name search regardless of year
// //   useEffect(() => {
// //     let isActive = true;
    
// //     const fetchAllStudents = async () => {
// //       try {
// //         const response = await axios.get(`${apiUrl}/api/students/all`);
// //         if (isActive && response.data && Array.isArray(response.data.students)) {
// //           const studentsWithNames = response.data.students.map(student => ({
// //             ...student,
// //             name: student.name || `${student.first_name || ''} ${student.last_name || ''}`.trim() || 'Unknown Student'
// //           }));
// //           setAllStudents(studentsWithNames);
// //         }
// //       } catch (error) {
// //         console.error("Error fetching all students:", error);
// //       }
// //     };

// //     fetchAllStudents();
    
// //     return () => {
// //       isActive = false;
// //     };
// //   }, [apiUrl]);




// //   // Fetch unique courses from reports
// //   useEffect(() => {
// //     const fetchReports = async () => {
// //       try {
// //         const [pendingResponse, statsResponse] = await Promise.all([
// //           fetch(`${apiUrl}/api/get-all-report-pdfs`),
// //           fetch(`${apiUrl}/api/report-stats`)
// //         ]);

// //         const pendingData = await pendingResponse.json();
// //         const statsData = await statsResponse.json();

// //         console.log('get-all-report-pdfs data:', pendingData);
// //         console.log('report-stats data:', statsData);

// //         const allReports = [...pendingData, ...statsData];
// //         const courses = [...new Set(allReports
// //           .filter(report => report.course_name)
// //           .map(report => report.course_name))];
        
// //         setUniqueCourses(courses);
// //       } catch (error) {
// //         console.error("Error fetching courses:", error);
// //       }
// //     };

// //     fetchReports();
// //   }, [apiUrl]);

// //   // Filter course suggestions
// //   const courseSuggestions = courseName
// //     ? uniqueCourses.filter(course => 
// //         course.toLowerCase().includes(courseName.toLowerCase())
// //       ).slice(0, 10)
// //     : [];

// //   // Handle course selection from suggestions
// //   const handleSelectCourse = (selectedCourse) => {
// //     setCourseName(selectedCourse);
// //     setShowCourseSuggestions(false);
// //   };

// //   // Fetch students when year changes
// //   useEffect(() => {
// //     let isActive = true;
    
// //     if (!selectedYear) {
// //       setStudents([]);
// //       return;
// //     }

// //     const fetchStudents = async () => {
// //       try {
// //         const response = await axios.get(`${apiUrl}/api/students?year=${selectedYear}`);
// //         if (isActive) {
// //           const studentsWithNames = (response.data.students || []).map(student => ({
// //             ...student,
// //             name: student.name || `${student.first_name || ''} ${student.last_name || ''}`.trim() || 'Unknown Student'
// //           }));
// //           setStudents(studentsWithNames);
// //         }
// //       } catch (error) {
// //         console.error("Error fetching students:", error);
// //         if (isActive) {
// //           setStudents([]);
// //         }
// //       }
// //     };

// //     fetchStudents();
    
// //     return () => {
// //       isActive = false;
// //     };
// //   }, [selectedYear, apiUrl]);

// //   // Filter student suggestions by name (use allStudents if no year selected)
// //   const nameSuggestions = studentName
// //     ? (selectedYear ? students : allStudents).filter(student => 
// //         student.name.toLowerCase().includes(studentName.toLowerCase()) || 
// //         (student.username && student.username.toLowerCase().includes(studentName.toLowerCase()))
// //       ).slice(0, 10) // Limit to 10 suggestions for performance
// //     : [];
    
// //   // Filter student suggestions by username (use allStudents if no year selected)
// //   const usernameSuggestions = username
// //     ? (selectedYear ? students : allStudents).filter(student => 
// //         (student.username && student.username.toLowerCase().includes(username.toLowerCase())) ||
// //         student.name.toLowerCase().includes(username.toLowerCase())
// //       ).slice(0, 10) // Limit to 10 suggestions for performance
// //     : [];

// //   // Handle student selection from suggestions
// //   const handleSelectStudent = (student, type) => {
// //     if (type === 'name') {
// //       setStudentName(student.name);
// //       setUsername(student.username || '');
// //       setShowNameSuggestions(false);
// //     } else {
// //       setUsername(student.username || '');
// //       setStudentName(student.name);
// //       setShowUsernameSuggestions(false);
// //     }
// //   };

// //   // Reset form
// //   const handleReset = () => {
// //     setStudentName('');
// //     setUsername('');
// //     setSelectedYear('');
// //     setStatus('');
// //     setFromDate('');
// //     setToDate('');
// //     setCourseName('');
// //     setReports([]);
// //     setError(null);
// //     setSelectedPdf(null);
// //   };

// //   // Get student name
// //   // const getStudentName = (studentUsername, report) => {
// //   //   if (!studentUsername) return '-';
    
// //   //   // Check if name is directly in the report
// //   //   if (report && report.name) return report.name;
// //   //   if (report && report.student_name) return report.student_name;
    
// //   //   // Try to find full name from first and last name
// //   //   if (report && report.first_name && report.last_name) {
// //   //     return `${report.first_name} ${report.last_name}`.trim();
// //   //   }
    
// //   //   // Try to find in students array
// //   //   const student = [...students, ...allStudents].find(s => s.username === studentUsername);
// //   //   return student ? student.name : '-';
// //   // };

// //   // Get course name
// //   const getCourseName = (report) => {
// //     if (!report) return '-';
// //     return report.course_name || report.course || '-';
// //   };

// //   // Format date for API request
// //   // const formatDateParam = (date) => date ? new Date(date).toISOString().slice(0, 10) : '';

// //   // Format date for display
// //   const formatDate = (dateString) => {
// //     if (!dateString) return '-';
// //     return new Date(dateString).toLocaleDateString('en-US', {
// //       year: 'numeric', 
// //       month: 'long', 
// //       day: 'numeric', 
// //       hour: '2-digit', 
// //       minute: '2-digit'
// //     });
// //   };

// //   // Search for reports
// //   const handleSearch = async (e) => {
// //     if (e) e.preventDefault();
// //     // Alert if no filter is applied
// //     if (!isAnyFilterApplied()) {
// //       alert('Please enter at least one filter before searching.');
// //       return;
// //     }
// //     setLoading(true);
// //     setError(null);

// //     try {
// //       // Fetch pending reports
// //       const pendingResponse = await fetch(`${apiUrl}/api/get-all-report-pdfs`);
// //       if (!pendingResponse.ok) throw new Error('Failed to fetch pending reports');
// //       const pendingReports = await pendingResponse.json();

// //       // Fetch approved/rejected reports
// //       const statsResponse = await fetch(`${apiUrl}/api/report-stats`);
// //       if (!statsResponse.ok) throw new Error('Failed to fetch approved/rejected reports');
// //       const statsReports = await statsResponse.json();

// //       // Merge both
// //       let allReports = [...pendingReports, ...statsReports];

// //       // Remove duplicates (by id or registration_id)
// //       const uniqueIds = new Set();
// //       allReports = allReports.filter(report => {
// //         const id = report.id || report.registration_id;
// //         if (uniqueIds.has(id)) return false;
// //         uniqueIds.add(id);
// //         return true;
// //       });

// //       // Fix: toDate should include the whole day
// //       const toDateObj = toDate ? new Date(toDate + 'T23:59:59.999') : null;

// //       // 2. Client-side filtering
// //       const filteredReports = allReports.filter(report =>
// //         report.teacher_username === user.username &&
// //         (!studentName ||
// //           ((report.name && report.name.toLowerCase().includes(studentName.toLowerCase())) ||
// //            (report.username && report.username.toLowerCase().includes(studentName.toLowerCase())))
// //         ) &&
// //         (!username || (report.username) === username) &&
// //         (!courseName || (report.course_name && report.course_name.toLowerCase().includes(courseName.toLowerCase()))) &&
// //         (!selectedYear || String(report.year) === String(selectedYear)) &&
// //         (!status || report.status === status) &&
// //         (!fromDate || new Date(report.reported_at) >= new Date(fromDate)) &&
// //         (!toDate || new Date(report.reported_at) <= toDateObj)
// //       );

// //       setReports(filteredReports);
// //       if (filteredReports.length === 0) {
// //         setError('No reports found for the selected filters');
// //       }
// //     } catch (err) {
// //       setError(err.message || 'Failed to fetch reports. Please try again.');
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   // Toggle PDF view
// //   const toggleViewReport = async (report) => {
// //     if (selectedPdf === report.id) {
// //       setSelectedPdf(null);
// //       return;
// //     }
    
// //     setSelectedPdf(report.id);
// //     if (pdfUrls[report.id]) return;

// //     setLoadingPdf(true);
    
// //     try {
// //       const response = await fetch(`${apiUrl}/api/reports/${report.registration_id}/pdf`);
// //       if (!response.ok) throw new Error(`HTTP ${response.status}`);
      
// //       const blob = await response.blob();
// //       const url = URL.createObjectURL(blob);
      
// //       setPdfUrls(prev => ({
// //         ...prev,
// //         [report.id]: url
// //       }));
// //     } catch (err) {
// //       console.error('Error loading PDF:', err);
// //       alert('Failed to load report PDF.');
// //     } finally {
// //       setLoadingPdf(false);
// //     }
// //   };

// //   // Calculate status counts
// //   const statusCounts = {
// //     pending: reports.filter(r => r.status === 'pending').length,
// //     approved: reports.filter(r => r.status === 'approved').length,
// //     rejected: reports.filter(r => r.status === 'rejected').length
// //   };

// //   // Helper to check if any filter is applied
// //   const isAnyFilterApplied = () => {
// //     return (
// //       studentName ||
// //       username ||
// //       courseName ||
// //       selectedYear ||
// //       status ||
// //       fromDate ||
// //       toDate
// //     );
// //   };

// //   // Handle keyboard navigation for name suggestions
// //   const handleNameKeyDown = (e) => {
// //     if (!showNameSuggestions || nameSuggestions.length === 0) return;
// //     if (e.key === 'ArrowDown') {
// //       e.preventDefault();
// //       setNameSuggestionIndex((prev) => (prev + 1) % nameSuggestions.length);
// //     } else if (e.key === 'ArrowUp') {
// //       e.preventDefault();
// //       setNameSuggestionIndex((prev) => (prev - 1 + nameSuggestions.length) % nameSuggestions.length);
// //     } else if (e.key === 'Enter') {
// //       if (nameSuggestionIndex >= 0 && nameSuggestionIndex < nameSuggestions.length) {
// //         handleSelectStudent(nameSuggestions[nameSuggestionIndex], 'name');
// //         setNameSuggestionIndex(-1);
// //       }
// //     } else if (e.key === 'Escape') {
// //       setShowNameSuggestions(false);
// //       setNameSuggestionIndex(-1);
// //     }
// //   };

// //   // Handle keyboard navigation for username suggestions
// //   const handleUsernameKeyDown = (e) => {
// //     if (!showUsernameSuggestions || usernameSuggestions.length === 0) return;
// //     if (e.key === 'ArrowDown') {
// //       e.preventDefault();
// //       setUsernameSuggestionIndex((prev) => (prev + 1) % usernameSuggestions.length);
// //     } else if (e.key === 'ArrowUp') {
// //       e.preventDefault();
// //       setUsernameSuggestionIndex((prev) => (prev - 1 + usernameSuggestions.length) % usernameSuggestions.length);
// //     } else if (e.key === 'Enter') {
// //       if (usernameSuggestionIndex >= 0 && usernameSuggestionIndex < usernameSuggestions.length) {
// //         handleSelectStudent(usernameSuggestions[usernameSuggestionIndex], 'username');
// //         setUsernameSuggestionIndex(-1);
// //       }
// //     } else if (e.key === 'Escape') {
// //       setShowUsernameSuggestions(false);
// //       setUsernameSuggestionIndex(-1);
// //     }
// //   };

// //   // Handle keyboard navigation for course suggestions
// //   const handleCourseKeyDown = (e) => {
// //     if (!showCourseSuggestions || courseSuggestions.length === 0) {
// //       if (e.key === 'Enter') {
// //         e.target.form && e.target.form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
// //       }
// //       return;
// //     }
// //     if (e.key === 'ArrowDown') {
// //       e.preventDefault();
// //       setCourseSuggestionIndex((prev) => (prev + 1) % courseSuggestions.length);
// //     } else if (e.key === 'ArrowUp') {
// //       e.preventDefault();
// //       setCourseSuggestionIndex((prev) => (prev - 1 + courseSuggestions.length) % courseSuggestions.length);
// //     } else if (e.key === 'Enter') {
// //       if (courseSuggestionIndex >= 0 && courseSuggestionIndex < courseSuggestions.length) {
// //         handleSelectCourse(courseSuggestions[courseSuggestionIndex]);
// //         setCourseSuggestionIndex(-1);
// //       }
// //     } else if (e.key === 'Escape') {
// //       setShowCourseSuggestions(false);
// //       setCourseSuggestionIndex(-1);
// //     }
// //   };

// //   return (
// //     <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-50 py-8 px-4">
// //       <div className="max-w-6xl mx-auto">
// //         {/* Search Section */}
// //         <div className="bg-white rounded-3xl shadow-lg mb-8 p-8">
// //           <h2 className="text-2xl font-bold text-gray-700 mb-6">Student Reports</h2>
// //           <div className="border-b mb-6" />
// //           <form onSubmit={handleSearch}>
// //             <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-6">
// //               <div>
// //                 <label className="block text-sm font-semibold text-gray-600 mb-2">Student Name</label>
// //                 <div className="relative">
// //                   <input
// //                     type="text"
// //                     placeholder="Type for hints..."
// //                     value={studentName}
// //                     onChange={(e) => { setStudentName(e.target.value); setNameSuggestionIndex(-1); }}
// //                     onFocus={() => setShowNameSuggestions(true)}
// //                     onBlur={() => setTimeout(() => setShowNameSuggestions(false), 150)}
// //                     onKeyDown={handleNameKeyDown}
// //                     className="w-full p-3 rounded-lg border border-gray-200 focus:ring-2 focus:ring-blue-200 focus:border-blue-400 text-gray-700 bg-gray-50"
// //                   />
// //                   {showNameSuggestions && nameSuggestions.length > 0 && (
// //                     <ul className="absolute z-10 left-0 right-0 bg-white border border-gray-200 rounded-lg mt-1 max-h-48 overflow-y-auto shadow-lg">
// //                       {nameSuggestions.map((student, idx) => (
// //                         <li
// //                           key={student.id || student.username}
// //                           className={`px-4 py-2 cursor-pointer hover:bg-blue-50 ${idx === nameSuggestionIndex ? 'bg-blue-100' : ''}`}
// //                           onMouseDown={() => handleSelectStudent(student, 'name')}
// //                         >
// //                           <span className="font-medium text-gray-800">{student.name}</span>
// //                           <span className="text-gray-500 ml-2 text-xs">@{student.username}</span>
// //                         </li>
// //                       ))}
// //                     </ul>
// //                   )}
// //                 </div>
// //               </div>
// //               <div>
// //                 <label className="block text-sm font-semibold text-gray-600 mb-2">Username</label>
// //                 <div className="relative">
// //                   <input
// //                     type="text"
// //                     placeholder="Type for hints..."
// //                     value={username}
// //                     onChange={(e) => { setUsername(e.target.value); setUsernameSuggestionIndex(-1); }}
// //                     onFocus={() => setShowUsernameSuggestions(true)}
// //                     onBlur={() => setTimeout(() => setShowUsernameSuggestions(false), 150)}
// //                     onKeyDown={handleUsernameKeyDown}
// //                     className="w-full p-3 rounded-lg border border-gray-200 focus:ring-2 focus:ring-blue-200 focus:border-blue-400 text-gray-700 bg-gray-50"
// //                   />
// //                   {showUsernameSuggestions && usernameSuggestions.length > 0 && (
// //                     <ul className="absolute z-10 left-0 right-0 bg-white border border-gray-200 rounded-lg mt-1 max-h-48 overflow-y-auto shadow-lg">
// //                       {usernameSuggestions.map((student, idx) => (
// //                         <li
// //                           key={student.id || student.username}
// //                           className={`px-4 py-2 cursor-pointer hover:bg-blue-50 ${idx === usernameSuggestionIndex ? 'bg-blue-100' : ''}`}
// //                           onMouseDown={() => handleSelectStudent(student, 'username')}
// //                         >
// //                           <span className="font-medium text-gray-500">@{student.username}</span>
// //                           <span className="text-gray-800 ml-2">{student.name}</span>
// //                         </li>
// //                       ))}
// //                     </ul>
// //                   )}
// //                 </div>
// //               </div>
// //               <div>
// //                 <label className="block text-sm font-semibold text-gray-600 mb-2">Course Name</label>
// //                 <div className="relative">
// //                   <input
// //                     type="text"
// //                     placeholder="Type for hints..."
// //                     value={courseName}
// //                     onChange={(e) => { setCourseName(e.target.value); setCourseSuggestionIndex(-1); }}
// //                     onFocus={() => setShowCourseSuggestions(true)}
// //                     onBlur={() => setTimeout(() => setShowCourseSuggestions(false), 150)}
// //                     onKeyDown={handleCourseKeyDown}
// //                     className="w-full p-3 rounded-lg border border-gray-200 focus:ring-2 focus:ring-blue-200 focus:border-blue-400 text-gray-700 bg-gray-50"
// //                   />
// //                   {showCourseSuggestions && courseSuggestions.length > 0 && (
// //                     <ul className="absolute z-10 left-0 right-0 bg-white border border-gray-200 rounded-lg mt-1 max-h-48 overflow-y-auto shadow-lg">
// //                       {courseSuggestions.map((course, idx) => (
// //                         <li
// //                           key={idx}
// //                           className={`px-4 py-2 cursor-pointer hover:bg-blue-50 ${idx === courseSuggestionIndex ? 'bg-blue-100' : ''}`}
// //                           onMouseDown={() => handleSelectCourse(course)}
// //                         >
// //                           <span className="font-medium text-gray-800">{course}</span>
// //                         </li>
// //                       ))}
// //                     </ul>
// //                   )}
// //                 </div>
// //               </div>
// //               <div>
// //                 <label className="block text-sm font-semibold text-gray-600 mb-2">Year</label>
// //                 <select
// //                   value={selectedYear}
// //                   onChange={(e) => setSelectedYear(e.target.value)}
// //                   className="w-full p-3 rounded-lg border border-gray-200 focus:ring-2 focus:ring-blue-200 focus:border-blue-400 text-gray-700 bg-gray-50 appearance-none"
// //                 >
// //                   <option value="">-- Select --</option>
// //                   {YEARS.map(year => (
// //                     <option key={year.id} value={year.id}>{year.name}</option>
// //                   ))}
// //                 </select>
// //               </div>
// //             </div>
// //             <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
// //               <div>
// //                 <label className="block text-sm font-semibold text-gray-600 mb-2">Status</label>
// //                 <select
// //                   value={status}
// //                   onChange={(e) => setStatus(e.target.value)}
// //                   className="w-full p-3 rounded-lg border border-gray-200 focus:ring-2 focus:ring-blue-200 focus:border-blue-400 text-gray-700 bg-gray-50 appearance-none"
// //                 >
// //                   <option value="">-- Select --</option>
// //                   <option value="pending">Pending</option>
// //                   <option value="approved">Approved</option>
// //                   <option value="rejected">Rejected</option>
// //                 </select>
// //               </div>
// //               <div>
// //                 <label className="block text-sm font-semibold text-gray-600 mb-2">From Date</label>
// //                 <input
// //                   type="date"
// //                   value={fromDate}
// //                   onChange={(e) => setFromDate(e.target.value)}
// //                   className="w-full p-3 rounded-lg border border-gray-200 focus:ring-2 focus:ring-blue-200 focus:border-blue-400 text-gray-700 bg-gray-50"
// //                 />
// //               </div>
// //               <div>
// //                 <label className="block text-sm font-semibold text-gray-600 mb-2">To Date</label>
// //                 <input
// //                   type="date"
// //                   value={toDate}
// //                   onChange={(e) => setToDate(e.target.value)}
// //                   className="w-full p-3 rounded-lg border border-gray-200 focus:ring-2 focus:ring-blue-200 focus:border-blue-400 text-gray-700 bg-gray-50"
// //                 />
// //               </div>
// //             </div>
// //             <div className="flex justify-end gap-4">
// //               <button
// //                 type="button"
// //                 onClick={handleReset}
// //                 className="px-8 py-2 border-2 border-purple-500 text-purple-600 rounded-full font-semibold bg-white hover:bg-purple-50 transition"
// //               >
// //                 Reset
// //               </button>
// //               <button
// //                 type="submit"
// //                 className="px-8 py-2 bg-purple-600 text-white rounded-full font-semibold hover:bg-purple-700 transition"
// //               >
// //                 Search
// //               </button>
// //             </div>
// //           </form>
// //         </div>

// //         {/* Results Section */}
// //         {loading ? (
// //           <div className="flex justify-center py-12">
// //             <FaSpinner className="animate-spin text-4xl text-blue-600" />
// //           </div>
// //         ) : error && isAnyFilterApplied() ? (
// //           <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-6">
// //             <strong>Error:</strong> {error}
// //           </div>
// //         ) : reports.length > 0 ? (
// //           <div className="overflow-x-auto bg-white rounded-xl shadow-sm p-4">
// //             <div className="mb-4 flex flex-wrap gap-4 items-center">
// //               <div className="px-4 py-2 rounded-lg bg-yellow-100 text-yellow-800 font-semibold text-sm">
// //                 Pending: {statusCounts.pending}
// //               </div>
// //               <div className="px-4 py-2 rounded-lg bg-green-100 text-green-800 font-semibold text-sm">
// //                 Approved: {statusCounts.approved}
// //               </div>
// //               <div className="px-4 py-2 rounded-lg bg-red-100 text-red-800 font-semibold text-sm">
// //                 Rejected: {statusCounts.rejected}
// //               </div>
// //             </div>
// //             <table className="min-w-full divide-y divide-gray-200">
// //               <thead className="bg-gray-50">
// //                 <tr>
// //                   <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600">S.No.</th>
// //                   <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600">Student Name</th>
// //                   <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600">Username</th>
// //                   <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600">Course Name</th>
// //                   <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600">Year</th>
// //                   <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600">Status</th>
// //                   <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600">Date</th>
// //                   <th className="px-4 py-3 text-center text-xs font-semibold text-gray-600">Actions</th>
// //                 </tr>
// //               </thead>
// //               <tbody className="bg-white divide-y divide-gray-100">
// //                 {reports.map((report, idx) => (
// //                   <React.Fragment key={report.id || idx}>
// //                     <tr className="hover:bg-blue-50 transition">
// //                       <td className="px-4 py-3 text-sm text-gray-700">{idx + 1}</td>
// //                       <td className="px-4 py-3 text-sm text-gray-900 font-medium">
// //                         {report.name || report.username || 'Not specified'}
// //                       </td>
// //                       <td className="px-4 py-3 text-sm text-gray-700">{report.username}</td>
// //                       <td className="px-4 py-3 text-sm text-gray-700">{getCourseName(report)}</td>
// //                       <td className="px-4 py-3 text-sm text-gray-700">{report.year || '-'}</td>
// //                       <td className="px-4 py-3 text-sm">
// //                         <span className={`px-2 py-1 rounded-full text-xs font-semibold ${
// //                           report.status === 'approved' ? 'bg-green-100 text-green-700' :
// //                           report.status === 'pending' ? 'bg-yellow-100 text-yellow-700' :
// //                           report.status === 'rejected' ? 'bg-red-100 text-red-700' :
// //                           'bg-gray-100 text-gray-700'
// //                         }`}>
// //                           {report.status ? report.status.charAt(0).toUpperCase() + report.status.slice(1) : '-'}
// //                         </span>
// //                       </td>
// //                       <td className="px-4 py-3 text-sm text-gray-700">{formatDate(report.reported_at)}</td>
// //                       <td className="px-4 py-3 text-center flex gap-2 justify-center">
// //                         <button
// //                           onClick={() => toggleViewReport(report)}
// //                           className="py-1 px-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors flex items-center gap-1 text-xs"
// //                         >
// //                           {selectedPdf === report.id ? <FaEyeSlash /> : <FaEye />}
// //                           {selectedPdf === report.id ? 'Hide' : 'View'}
// //                         </button>
// //                         {pdfUrls[report.id] && (
// //                           <a
// //                             href={pdfUrls[report.id]}
// //                             download={`report_${report.username}_${report.id}.pdf`}
// //                             className="py-1 px-3 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors flex items-center gap-1 text-xs"
// //                           >
// //                             <FaDownload />
// //                             Download
// //                           </a>
// //                         )}
// //                       </td>
// //                     </tr>
// //                     {selectedPdf === report.id && (
// //                       <tr>
// //                         <td colSpan={8} className="bg-gray-50 px-4 py-4">
// //                           {loadingPdf ? (
// //                             <div className="flex justify-center py-12">
// //                               <FaSpinner className="animate-spin text-4xl text-blue-600" />
// //                             </div>
// //                           ) : (
// //                             pdfUrls[report.id] && (
// //                               <iframe
// //                                 src={pdfUrls[report.id]}
// //                                 className="w-full h-[500px] border rounded-lg"
// //                                 title={`PDF Report ${report.id}`}
// //                               />
// //                             )
// //                           )}
// //                         </td>
// //                       </tr>
// //                     )}
// //                   </React.Fragment>
// //                 ))}
// //               </tbody>
// //             </table>
// //           </div>
// //         ) : null}
// //       </div>
// //     </div>
// //   );
// // };

// // export default TeacherReport;














// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { FaDownload, FaSpinner, FaEye, FaEyeSlash } from 'react-icons/fa';
// import { useUser } from '../UserContext';

// // Years data outside component to avoid re-creation
// const YEARS = [
//   { id: '1', name: '1st Year' },
//   { id: '2', name: '2nd Year' },
//   { id: '3', name: '3rd Year' },
//   { id: '4', name: '4th Year' },
// ];

// const TeacherReport = () => {
//   const { user } = useUser();
//   const apiUrl = (process.env.REACT_APP_API_URL || 'http://localhost:5001').trim();

//   // Form state
//   const [studentName, setStudentName] = useState('');
//   const [username, setUsername] = useState('');
//   const [selectedYear, setSelectedYear] = useState('');
//   const [status, setStatus] = useState('');
//   const [fromDate, setFromDate] = useState('');
//   const [toDate, setToDate] = useState('');
//   const [courseName, setCourseName] = useState('');

//   // Data state
//   const [students, setStudents] = useState([]);
//   const [reports, setReports] = useState([]);
//   const [selectedPdf, setSelectedPdf] = useState(null);
//   const [pdfUrls, setPdfUrls] = useState({});

//   // UI state
//   const [loading, setLoading] = useState(false);
//   const [loadingPdf, setLoadingPdf] = useState(false);
//   const [error, setError] = useState(null);
//   const [showNameSuggestions, setShowNameSuggestions] = useState(false);
//   const [showUsernameSuggestions, setShowUsernameSuggestions] = useState(false);
//   const [showCourseSuggestions, setShowCourseSuggestions] = useState(false);
//   const [allStudents, setAllStudents] = useState([]);
//   const [uniqueCourses, setUniqueCourses] = useState([]);
//   const [nameSuggestionIndex, setNameSuggestionIndex] = useState(-1);
//   const [usernameSuggestionIndex, setUsernameSuggestionIndex] = useState(-1);
//   const [courseSuggestionIndex, setCourseSuggestionIndex] = useState(-1);

//   // Fetch all students for name search regardless of year
//   useEffect(() => {
//     let isActive = true;
    
//     const fetchAllStudents = async () => {
//       try {
//         const response = await axios.get(`${apiUrl}/api/students/all`);
//         if (isActive && response.data && Array.isArray(response.data.students)) {
//           const studentsWithNames = response.data.students.map(student => ({
//             ...student,
//             name: student.name || `${student.first_name || ''} ${student.last_name || ''}`.trim() || 'Unknown Student'
//           }));
//           setAllStudents(studentsWithNames);
//         }
//       } catch (error) {
//         console.error("Error fetching all students:", error);
//       }
//     };

//     fetchAllStudents();
    
//     return () => {
//       isActive = false;
//     };
//   }, [apiUrl]);




//   // Fetch unique courses from reports
//   useEffect(() => {
//     const fetchReports = async () => {
//       try {
//         const [pendingResponse, statsResponse] = await Promise.all([
//           fetch(`${apiUrl}/api/get-all-report-pdfs`),
//           fetch(`${apiUrl}/api/report-stats`)
//         ]);

//         const pendingData = await pendingResponse.json();
//         const statsData = await statsResponse.json();

//         console.log('get-all-report-pdfs data:', pendingData);
//         console.log('report-stats data:', statsData);

//         const allReports = [...pendingData, ...statsData];
//         const courses = [...new Set(allReports
//           .filter(report => report.course_name)
//           .map(report => report.course_name))];
        
//         setUniqueCourses(courses);
//       } catch (error) {
//         console.error("Error fetching courses:", error);
//       }
//     };

//     fetchReports();
//   }, [apiUrl]);

//   // Filter course suggestions
//   const courseSuggestions = courseName
//     ? uniqueCourses.filter(course => 
//         course.toLowerCase().includes(courseName.toLowerCase())
//       ).slice(0, 10)
//     : [];

//   // Handle course selection from suggestions
//   const handleSelectCourse = (selectedCourse) => {
//     setCourseName(selectedCourse);
//     setShowCourseSuggestions(false);
//   };

//   // Fetch students when year changes
//   useEffect(() => {
//     let isActive = true;
    
//     if (!selectedYear) {
//       setStudents([]);
//       return;
//     }

//     const fetchStudents = async () => {
//       try {
//         const response = await axios.get(`${apiUrl}/api/students?year=${selectedYear}`);
//         if (isActive) {
//           const studentsWithNames = (response.data.students || []).map(student => ({
//             ...student,
//             name: student.name || `${student.first_name || ''} ${student.last_name || ''}`.trim() || 'Unknown Student'
//           }));
//           setStudents(studentsWithNames);
//         }
//       } catch (error) {
//         console.error("Error fetching students:", error);
//         if (isActive) {
//           setStudents([]);
//         }
//       }
//     };

//     fetchStudents();
    
//     return () => {
//       isActive = false;
//     };
//   }, [selectedYear, apiUrl]);

//   // Filter student suggestions by name (use allStudents if no year selected)
//   const nameSuggestions = studentName
//     ? (selectedYear ? students : allStudents).filter(student => 
//         student.name.toLowerCase().includes(studentName.toLowerCase()) || 
//         (student.username && student.username.toLowerCase().includes(studentName.toLowerCase()))
//       ).slice(0, 10) // Limit to 10 suggestions for performance
//     : [];
    
//   // Filter student suggestions by username (use allStudents if no year selected)
//   const usernameSuggestions = username
//     ? (selectedYear ? students : allStudents).filter(student => 
//         (student.username && student.username.toLowerCase().includes(username.toLowerCase())) ||
//         student.name.toLowerCase().includes(username.toLowerCase())
//       ).slice(0, 10) // Limit to 10 suggestions for performance
//     : [];

//   // Handle student selection from suggestions
//   const handleSelectStudent = (student, type) => {
//     if (type === 'name') {
//       setStudentName(student.name);
//       setUsername(student.username || '');
//       setShowNameSuggestions(false);
//     } else {
//       setUsername(student.username || '');
//       setStudentName(student.name);
//       setShowUsernameSuggestions(false);
//     }
//   };

//   // Reset form
//   const handleReset = () => {
//     setStudentName('');
//     setUsername('');
//     setSelectedYear('');
//     setStatus('');
//     setFromDate('');
//     setToDate('');
//     setCourseName('');
//     setReports([]);
//     setError(null);
//     setSelectedPdf(null);
//   };

//   // Get student name
//   // const getStudentName = (studentUsername, report) => {
//   //   if (!studentUsername) return '-';
    
//   //   // Check if name is directly in the report
//   //   if (report && report.name) return report.name;
//   //   if (report && report.student_name) return report.student_name;
    
//   //   // Try to find full name from first and last name
//   //   if (report && report.first_name && report.last_name) {
//   //     return `${report.first_name} ${report.last_name}`.trim();
//   //   }
    
//   //   // Try to find in students array
//   //   const student = [...students, ...allStudents].find(s => s.username === studentUsername);
//   //   return student ? student.name : '-';
//   // };

//   // Get course name
//   const getCourseName = (report) => {
//     if (!report) return '-';
//     return report.course_name || report.course || '-';
//   };

//   // Format date for API request
//   // const formatDateParam = (date) => date ? new Date(date).toISOString().slice(0, 10) : '';

//   // Format date for display
//   const formatDate = (dateString) => {
//     if (!dateString) return '-';
//     return new Date(dateString).toLocaleDateString('en-US', {
//       year: 'numeric', 
//       month: 'long', 
//       day: 'numeric', 
//       hour: '2-digit', 
//       minute: '2-digit'
//     });
//   };

//   // Search for reports
//   const handleSearch = async (e) => {
//     if (e) e.preventDefault();
//     // Alert if no filter is applied
//     if (!isAnyFilterApplied()) {
//       alert('Please enter at least one filter before searching.');
//       return;
//     }
//     setLoading(true);
//     setError(null);

//     try {
//       // Fetch pending reports
//       const pendingResponse = await fetch(`${apiUrl}/api/get-all-report-pdfs`);
//       if (!pendingResponse.ok) throw new Error('Failed to fetch pending reports');
//       const pendingReports = await pendingResponse.json();

//       // Fetch approved/rejected reports
//       const statsResponse = await fetch(`${apiUrl}/api/report-stats`);
//       if (!statsResponse.ok) throw new Error('Failed to fetch approved/rejected reports');
//       const statsReports = await statsResponse.json();

//       // Merge both
//       let allReports = [...pendingReports, ...statsReports];

//       // Remove duplicates (by id or registration_id)
//       const uniqueIds = new Set();
//       allReports = allReports.filter(report => {
//         const id = report.id || report.registration_id;
//         if (uniqueIds.has(id)) return false;
//         uniqueIds.add(id);
//         return true;
//       });

//       // Fix: toDate should include the whole day
//       const toDateObj = toDate ? new Date(toDate + 'T23:59:59.999') : null;

//       // 2. Client-side filtering
//       const filteredReports = allReports.filter(report =>
//         report.teacher_username === user.username &&
//         (!studentName ||
//           ((report.name && report.name.toLowerCase().includes(studentName.toLowerCase())) ||
//            (report.username && report.username.toLowerCase().includes(studentName.toLowerCase())))
//         ) &&
//         (!username || (report.username) === username) &&
//         (!courseName || (report.course_name && report.course_name.toLowerCase().includes(courseName.toLowerCase()))) &&
//         (!selectedYear || String(report.student_academic_year) === String(selectedYear)) &&
//         (!status || report.status === status) &&
//         (!fromDate || new Date(report.reported_at) >= new Date(fromDate)) &&
//         (!toDate || new Date(report.reported_at) <= toDateObj)
//       );

//       setReports(filteredReports);
//       if (filteredReports.length === 0) {
//         setError('No reports found for the selected filters');
//       }
//     } catch (err) {
//       setError(err.message || 'Failed to fetch reports. Please try again.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Toggle PDF view
//   const toggleViewReport = async (report) => {
//     if (selectedPdf === report.id) {
//       setSelectedPdf(null);
//       return;
//     }
    
//     setSelectedPdf(report.id);
//     if (pdfUrls[report.id]) return;

//     setLoadingPdf(true);
    
//     try {
//       const response = await fetch(`${apiUrl}/api/reports/${report.registration_id}/pdf`);
//       if (!response.ok) throw new Error(`HTTP ${response.status}`);
      
//       const blob = await response.blob();
//       const url = URL.createObjectURL(blob);
      
//       setPdfUrls(prev => ({
//         ...prev,
//         [report.id]: url
//       }));
//     } catch (err) {
//       console.error('Error loading PDF:', err);
//       alert('Failed to load report PDF.');
//     } finally {
//       setLoadingPdf(false);
//     }
//   };

//   // Calculate status counts
//   const statusCounts = {
//     pending: reports.filter(r => r.status === 'pending').length,
//     approved: reports.filter(r => r.status === 'approved').length,
//     rejected: reports.filter(r => r.status === 'rejected').length
//   };

//   // Helper to check if any filter is applied
//   const isAnyFilterApplied = () => {
//     return (
//       studentName ||
//       username ||
//       courseName ||
//       selectedYear ||
//       status ||
//       fromDate ||
//       toDate
//     );
//   };

//   // Handle keyboard navigation for name suggestions
//   const handleNameKeyDown = (e) => {
//     if (!showNameSuggestions || nameSuggestions.length === 0) return;
//     if (e.key === 'ArrowDown') {
//       e.preventDefault();
//       setNameSuggestionIndex((prev) => (prev + 1) % nameSuggestions.length);
//     } else if (e.key === 'ArrowUp') {
//       e.preventDefault();
//       setNameSuggestionIndex((prev) => (prev - 1 + nameSuggestions.length) % nameSuggestions.length);
//     } else if (e.key === 'Enter') {
//       if (nameSuggestionIndex >= 0 && nameSuggestionIndex < nameSuggestions.length) {
//         handleSelectStudent(nameSuggestions[nameSuggestionIndex], 'name');
//         setNameSuggestionIndex(-1);
//       }
//     } else if (e.key === 'Escape') {
//       setShowNameSuggestions(false);
//       setNameSuggestionIndex(-1);
//     }
//   };

//   // Handle keyboard navigation for username suggestions
//   const handleUsernameKeyDown = (e) => {
//     if (!showUsernameSuggestions || usernameSuggestions.length === 0) return;
//     if (e.key === 'ArrowDown') {
//       e.preventDefault();
//       setUsernameSuggestionIndex((prev) => (prev + 1) % usernameSuggestions.length);
//     } else if (e.key === 'ArrowUp') {
//       e.preventDefault();
//       setUsernameSuggestionIndex((prev) => (prev - 1 + usernameSuggestions.length) % usernameSuggestions.length);
//     } else if (e.key === 'Enter') {
//       if (usernameSuggestionIndex >= 0 && usernameSuggestionIndex < usernameSuggestions.length) {
//         handleSelectStudent(usernameSuggestions[usernameSuggestionIndex], 'username');
//         setUsernameSuggestionIndex(-1);
//       }
//     } else if (e.key === 'Escape') {
//       setShowUsernameSuggestions(false);
//       setUsernameSuggestionIndex(-1);
//     }
//   };

//   // Handle keyboard navigation for course suggestions
//   const handleCourseKeyDown = (e) => {
//     if (!showCourseSuggestions || courseSuggestions.length === 0) {
//       if (e.key === 'Enter') {
//         e.target.form && e.target.form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
//       }
//       return;
//     }
//     if (e.key === 'ArrowDown') {
//       e.preventDefault();
//       setCourseSuggestionIndex((prev) => (prev + 1) % courseSuggestions.length);
//     } else if (e.key === 'ArrowUp') {
//       e.preventDefault();
//       setCourseSuggestionIndex((prev) => (prev - 1 + courseSuggestions.length) % courseSuggestions.length);
//     } else if (e.key === 'Enter') {
//       if (courseSuggestionIndex >= 0 && courseSuggestionIndex < courseSuggestions.length) {
//         handleSelectCourse(courseSuggestions[courseSuggestionIndex]);
//         setCourseSuggestionIndex(-1);
//       }
//     } else if (e.key === 'Escape') {
//       setShowCourseSuggestions(false);
//       setCourseSuggestionIndex(-1);
//     }
//   };

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-50 py-8 px-4">
//       <div className="max-w-6xl mx-auto">
//         {/* Search Section */}
//         <div className="bg-white rounded-3xl shadow-lg mb-8 p-8">
//           <h2 className="text-2xl font-bold text-gray-700 mb-6">Student Reports</h2>
//           <div className="border-b mb-6" />
//           <form onSubmit={handleSearch}>
//             <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-6">
//               <div>
//                 <label className="block text-sm font-semibold text-gray-600 mb-2">Student Name</label>
//                 <div className="relative">
//                   <input
//                     type="text"
//                     placeholder="Type for hints..."
//                     value={studentName}
//                     onChange={(e) => { setStudentName(e.target.value); setNameSuggestionIndex(-1); }}
//                     onFocus={() => setShowNameSuggestions(true)}
//                     onBlur={() => setTimeout(() => setShowNameSuggestions(false), 150)}
//                     onKeyDown={handleNameKeyDown}
//                     className="w-full p-3 rounded-lg border border-gray-200 focus:ring-2 focus:ring-blue-200 focus:border-blue-400 text-gray-700 bg-gray-50"
//                   />
//                   {showNameSuggestions && nameSuggestions.length > 0 && (
//                     <ul className="absolute z-10 left-0 right-0 bg-white border border-gray-200 rounded-lg mt-1 max-h-48 overflow-y-auto shadow-lg">
//                       {nameSuggestions.map((student, idx) => (
//                         <li
//                           key={student.id || student.username}
//                           className={`px-4 py-2 cursor-pointer hover:bg-blue-50 ${idx === nameSuggestionIndex ? 'bg-blue-100' : ''}`}
//                           onMouseDown={() => handleSelectStudent(student, 'name')}
//                         >
//                           <span className="font-medium text-gray-800">{student.name}</span>
//                           <span className="text-gray-500 ml-2 text-xs">@{student.username}</span>
//                         </li>
//                       ))}
//                     </ul>
//                   )}
//                 </div>
//               </div>
//               <div>
//                 <label className="block text-sm font-semibold text-gray-600 mb-2">Username</label>
//                 <div className="relative">
//                   <input
//                     type="text"
//                     placeholder="Type for hints..."
//                     value={username}
//                     onChange={(e) => { setUsername(e.target.value); setUsernameSuggestionIndex(-1); }}
//                     onFocus={() => setShowUsernameSuggestions(true)}
//                     onBlur={() => setTimeout(() => setShowUsernameSuggestions(false), 150)}
//                     onKeyDown={handleUsernameKeyDown}
//                     className="w-full p-3 rounded-lg border border-gray-200 focus:ring-2 focus:ring-blue-200 focus:border-blue-400 text-gray-700 bg-gray-50"
//                   />
//                   {showUsernameSuggestions && usernameSuggestions.length > 0 && (
//                     <ul className="absolute z-10 left-0 right-0 bg-white border border-gray-200 rounded-lg mt-1 max-h-48 overflow-y-auto shadow-lg">
//                       {usernameSuggestions.map((student, idx) => (
//                         <li
//                           key={student.id || student.username}
//                           className={`px-4 py-2 cursor-pointer hover:bg-blue-50 ${idx === usernameSuggestionIndex ? 'bg-blue-100' : ''}`}
//                           onMouseDown={() => handleSelectStudent(student, 'username')}
//                         >
//                           <span className="font-medium text-gray-500">@{student.username}</span>
//                           <span className="text-gray-800 ml-2">{student.name}</span>
//                         </li>
//                       ))}
//                     </ul>
//                   )}
//                 </div>
//               </div>
//               <div>
//                 <label className="block text-sm font-semibold text-gray-600 mb-2">Course Name</label>
//                 <div className="relative">
//                   <input
//                     type="text"
//                     placeholder="Type for hints..."
//                     value={courseName}
//                     onChange={(e) => { setCourseName(e.target.value); setCourseSuggestionIndex(-1); }}
//                     onFocus={() => setShowCourseSuggestions(true)}
//                     onBlur={() => setTimeout(() => setShowCourseSuggestions(false), 150)}
//                     onKeyDown={handleCourseKeyDown}
//                     className="w-full p-3 rounded-lg border border-gray-200 focus:ring-2 focus:ring-blue-200 focus:border-blue-400 text-gray-700 bg-gray-50"
//                   />
//                   {showCourseSuggestions && courseSuggestions.length > 0 && (
//                     <ul className="absolute z-10 left-0 right-0 bg-white border border-gray-200 rounded-lg mt-1 max-h-48 overflow-y-auto shadow-lg">
//                       {courseSuggestions.map((course, idx) => (
//                         <li
//                           key={idx}
//                           className={`px-4 py-2 cursor-pointer hover:bg-blue-50 ${idx === courseSuggestionIndex ? 'bg-blue-100' : ''}`}
//                           onMouseDown={() => handleSelectCourse(course)}
//                         >
//                           <span className="font-medium text-gray-800">{course}</span>
//                         </li>
//                       ))}
//                     </ul>
//                   )}
//                 </div>
//               </div>
//               <div>
//                 <label className="block text-sm font-semibold text-gray-600 mb-2">Year</label>
//                 <select
//                   value={selectedYear}
//                   onChange={(e) => setSelectedYear(e.target.value)}
//                   className="w-full p-3 rounded-lg border border-gray-200 focus:ring-2 focus:ring-blue-200 focus:border-blue-400 text-gray-700 bg-gray-50 appearance-none"
//                 >
//                   <option value="">-- Select --</option>
//                   {YEARS.map(year => (
//                     <option key={year.id} value={year.id}>{year.name}</option>
//                   ))}
//                 </select>
//               </div>
//             </div>
//             <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
//               <div>
//                 <label className="block text-sm font-semibold text-gray-600 mb-2">Status</label>
//                 <select
//                   value={status}
//                   onChange={(e) => setStatus(e.target.value)}
//                   className="w-full p-3 rounded-lg border border-gray-200 focus:ring-2 focus:ring-blue-200 focus:border-blue-400 text-gray-700 bg-gray-50 appearance-none"
//                 >
//                   <option value="">-- Select --</option>
//                   <option value="pending">Pending</option>
//                   <option value="approved">Approved</option>
//                   <option value="rejected">Rejected</option>
//                 </select>
//               </div>
//               <div>
//                 <label className="block text-sm font-semibold text-gray-600 mb-2">From Date</label>
//                 <input
//                   type="date"
//                   value={fromDate}
//                   onChange={(e) => setFromDate(e.target.value)}
//                   className="w-full p-3 rounded-lg border border-gray-200 focus:ring-2 focus:ring-blue-200 focus:border-blue-400 text-gray-700 bg-gray-50"
//                 />
//               </div>
//               <div>
//                 <label className="block text-sm font-semibold text-gray-600 mb-2">To Date</label>
//                 <input
//                   type="date"
//                   value={toDate}
//                   onChange={(e) => setToDate(e.target.value)}
//                   className="w-full p-3 rounded-lg border border-gray-200 focus:ring-2 focus:ring-blue-200 focus:border-blue-400 text-gray-700 bg-gray-50"
//                 />
//               </div>
//             </div>
//             <div className="flex justify-end gap-4">
//               <button
//                 type="button"
//                 onClick={handleReset}
//                 className="px-8 py-2 border-2 border-purple-500 text-purple-600 rounded-full font-semibold bg-white hover:bg-purple-50 transition"
//               >
//                 Reset
//               </button>
//               <button
//                 type="submit"
//                 className="px-8 py-2 bg-purple-600 text-white rounded-full font-semibold hover:bg-purple-700 transition"
//               >
//                 Search
//               </button>
//             </div>
//           </form>
//         </div>

//         {/* Results Section */}
//         {loading ? (
//           <div className="flex justify-center py-12">
//             <FaSpinner className="animate-spin text-4xl text-blue-600" />
//           </div>
//         ) : error && isAnyFilterApplied() ? (
//           <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-6">
//             <strong>Error:</strong> {error}
//           </div>
//         ) : reports.length > 0 ? (
//           <div className="overflow-x-auto bg-white rounded-xl shadow-sm p-4">
//             <div className="mb-4 flex flex-wrap gap-4 items-center">
//               <div className="px-4 py-2 rounded-lg bg-yellow-100 text-yellow-800 font-semibold text-sm">
//                 Pending: {statusCounts.pending}
//               </div>
//               <div className="px-4 py-2 rounded-lg bg-green-100 text-green-800 font-semibold text-sm">
//                 Approved: {statusCounts.approved}
//               </div>
//               <div className="px-4 py-2 rounded-lg bg-red-100 text-red-800 font-semibold text-sm">
//                 Rejected: {statusCounts.rejected}
//               </div>
//             </div>
//             <table className="min-w-full divide-y divide-gray-200">
//               <thead className="bg-gray-50">
//                 <tr>
//                   <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600">S.No.</th>
//                   <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600">Student Name</th>
//                   <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600">Username</th>
//                   <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600">Course Name</th>
//                   <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600">Year</th>
//                   <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600">Status</th>
//                   <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600">Date</th>
//                   <th className="px-4 py-3 text-center text-xs font-semibold text-gray-600">Actions</th>
//                 </tr>
//               </thead>
//               <tbody className="bg-white divide-y divide-gray-100">
//                 {reports.map((report, idx) => (
//                   <React.Fragment key={report.id || idx}>
//                     <tr className="hover:bg-blue-50 transition">
//                       <td className="px-4 py-3 text-sm text-gray-700">{idx + 1}</td>
//                       <td className="px-4 py-3 text-sm text-gray-900 font-medium">
//                         {report.name || report.username || 'Not specified'}
//                       </td>
//                       <td className="px-4 py-3 text-sm text-gray-700">{report.username}</td>
//                       <td className="px-4 py-3 text-sm text-gray-700">{getCourseName(report)}</td>
//                       <td className="px-4 py-3 text-sm text-gray-700">{report.student_academic_year || '-'}</td>
//                       <td className="px-4 py-3 text-sm">
//                         <span className={`px-2 py-1 rounded-full text-xs font-semibold ${
//                           report.status === 'approved' ? 'bg-green-100 text-green-700' :
//                           report.status === 'pending' ? 'bg-yellow-100 text-yellow-700' :
//                           report.status === 'rejected' ? 'bg-red-100 text-red-700' :
//                           'bg-gray-100 text-gray-700'
//                         }`}>
//                           {report.status ? report.status.charAt(0).toUpperCase() + report.status.slice(1) : '-'}
//                         </span>
//                       </td>
//                       <td className="px-4 py-3 text-sm text-gray-700">{formatDate(report.reported_at)}</td>
//                       <td className="px-4 py-3 text-center flex gap-2 justify-center">
//                         <button
//                           onClick={() => toggleViewReport(report)}
//                           className="py-1 px-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors flex items-center gap-1 text-xs"
//                         >
//                           {selectedPdf === report.id ? <FaEyeSlash /> : <FaEye />}
//                           {selectedPdf === report.id ? 'Hide' : 'View'}
//                         </button>
//                         {pdfUrls[report.id] && (
//                           <a
//                             href={pdfUrls[report.id]}
//                             download={`report_${report.username}_${report.id}.pdf`}
//                             className="py-1 px-3 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors flex items-center gap-1 text-xs"
//                           >
//                             <FaDownload />
//                             Download
//                           </a>
//                         )}
//                       </td>
//                     </tr>
//                     {selectedPdf === report.id && (
//                       <tr>
//                         <td colSpan={8} className="bg-gray-50 px-4 py-4">
//                           {loadingPdf ? (
//                             <div className="flex justify-center py-12">
//                               <FaSpinner className="animate-spin text-4xl text-blue-600" />
//                             </div>
//                           ) : (
//                             pdfUrls[report.id] && (
//                               <iframe
//                                 src={pdfUrls[report.id]}
//                                 className="w-full h-[500px] border rounded-lg"
//                                 title={`PDF Report ${report.id}`}
//                               />
//                             )
//                           )}
//                         </td>
//                       </tr>
//                     )}
//                   </React.Fragment>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         ) : null}
//       </div>
//     </div>
//   );
// };

// export default TeacherReport;


import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FaDownload, FaSpinner, FaEye, FaEyeSlash } from 'react-icons/fa';
import { useUser } from '../UserContext';

// Years data outside component to avoid re-creation
const YEARS = [
  { id: '1', name: '1st Year' },
  { id: '2', name: '2nd Year' },
  { id: '3', name: '3rd Year' },
  { id: '4', name: '4th Year' },
];

const TeacherReport = () => {
  const { user } = useUser();
  const apiUrl = (process.env.REACT_APP_API_URL || 'http://localhost:5001').trim();

  // Form state
  const [studentName, setStudentName] = useState('');
  const [username, setUsername] = useState('');
  const [selectedYear, setSelectedYear] = useState('');
  const [status, setStatus] = useState('');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [courseName, setCourseName] = useState('');

  // Data state
  const [students, setStudents] = useState([]);
  const [reports, setReports] = useState([]);
  const [selectedPdf, setSelectedPdf] = useState(null);
  const [pdfUrls, setPdfUrls] = useState({});
  const [quizScores, setQuizScores] = useState({});

  // UI state
  const [loading, setLoading] = useState(false);
  const [loadingPdf, setLoadingPdf] = useState(false);
  const [error, setError] = useState(null);
  const [showNameSuggestions, setShowNameSuggestions] = useState(false);
  const [showUsernameSuggestions, setShowUsernameSuggestions] = useState(false);
  const [showCourseSuggestions, setShowCourseSuggestions] = useState(false);
  const [allStudents, setAllStudents] = useState([]);
  const [uniqueCourses, setUniqueCourses] = useState([]);
  const [nameSuggestionIndex, setNameSuggestionIndex] = useState(-1);
  const [usernameSuggestionIndex, setUsernameSuggestionIndex] = useState(-1);
  const [courseSuggestionIndex, setCourseSuggestionIndex] = useState(-1);

  // Fetch all students for name search regardless of year
  useEffect(() => {
    let isActive = true;
    
    const fetchAllStudents = async () => {
      try {
        const response = await axios.get(`${apiUrl}/api/students/all`);
        if (isActive && response.data && Array.isArray(response.data.students)) {
          const studentsWithNames = response.data.students.map(student => ({
            ...student,
            name: student.name || `${student.first_name || ''} ${student.last_name || ''}`.trim() || 'Unknown Student'
          }));
          setAllStudents(studentsWithNames);
        }
      } catch (error) {
        console.error("Error fetching all students:", error);
      }
    };

    fetchAllStudents();
    
    return () => {
      isActive = false;
    };
  }, [apiUrl]);




  // Fetch unique courses from reports
  useEffect(() => {
    const fetchReports = async () => {
      try {
        const [pendingResponse, statsResponse] = await Promise.all([
          fetch(`${apiUrl}/api/get-all-report-pdfs`),
          fetch(`${apiUrl}/api/report-stats`)
        ]);

        const pendingData = await pendingResponse.json();
        const statsData = await statsResponse.json();

        console.log('get-all-report-pdfs data:', pendingData);
        console.log('report-stats data:', statsData);

        const allReports = [...pendingData, ...statsData];
        const courses = [...new Set(allReports
          .filter(report => report.course_name)
          .map(report => report.course_name))];
        
        setUniqueCourses(courses);
      } catch (error) {
        console.error("Error fetching courses:", error);
      }
    };

    fetchReports();
  }, [apiUrl]);

  // Filter course suggestions
  const courseSuggestions = courseName
    ? uniqueCourses.filter(course => 
        course.toLowerCase().includes(courseName.toLowerCase())
      ).slice(0, 10)
    : [];

  // Handle course selection from suggestions
  const handleSelectCourse = (selectedCourse) => {
    setCourseName(selectedCourse);
    setShowCourseSuggestions(false);
  };

  // Fetch students when year changes
  useEffect(() => {
    let isActive = true;
    
    if (!selectedYear) {
      setStudents([]);
      return;
    }

    const fetchStudents = async () => {
      try {
        const response = await axios.get(`${apiUrl}/api/students?year=${selectedYear}`);
        if (isActive) {
          const studentsWithNames = (response.data.students || []).map(student => ({
            ...student,
            name: student.name || `${student.first_name || ''} ${student.last_name || ''}`.trim() || 'Unknown Student'
          }));
          setStudents(studentsWithNames);
        }
      } catch (error) {
        console.error("Error fetching students:", error);
        if (isActive) {
          setStudents([]);
        }
      }
    };

    fetchStudents();
    
    return () => {
      isActive = false;
    };
  }, [selectedYear, apiUrl]);

  // Filter student suggestions by name (use allStudents if no year selected)
  const nameSuggestions = studentName
    ? (selectedYear ? students : allStudents).filter(student => 
        student.name.toLowerCase().includes(studentName.toLowerCase()) || 
        (student.username && student.username.toLowerCase().includes(studentName.toLowerCase()))
      ).slice(0, 10) // Limit to 10 suggestions for performance
    : [];
    
  // Filter student suggestions by username (use allStudents if no year selected)
  const usernameSuggestions = username
    ? (selectedYear ? students : allStudents).filter(student => 
        (student.username && student.username.toLowerCase().includes(username.toLowerCase())) ||
        student.name.toLowerCase().includes(username.toLowerCase())
      ).slice(0, 10) // Limit to 10 suggestions for performance
    : [];

  // Handle student selection from suggestions
  const handleSelectStudent = (student, type) => {
    if (type === 'name') {
      setStudentName(student.name);
      setUsername(student.username || '');
      setShowNameSuggestions(false);
    } else {
      setUsername(student.username || '');
      setStudentName(student.name);
      setShowUsernameSuggestions(false);
    }
  };

  // Reset form
  const handleReset = () => {
    setStudentName('');
    setUsername('');
    setSelectedYear('');
    setStatus('');
    setFromDate('');
    setToDate('');
    setCourseName('');
    setReports([]);
    setError(null);
    setSelectedPdf(null);
  };

  // Get student name
  // const getStudentName = (studentUsername, report) => {
  //   if (!studentUsername) return '-';
    
  //   // Check if name is directly in the report
  //   if (report && report.name) return report.name;
  //   if (report && report.student_name) return report.student_name;
    
  //   // Try to find full name from first and last name
  //   if (report && report.first_name && report.last_name) {
  //     return `${report.first_name} ${report.last_name}`.trim();
  //   }
    
  //   // Try to find in students array
  //   const student = [...students, ...allStudents].find(s => s.username === studentUsername);
  //   return student ? student.name : '-';
  // };

  // Get course name
  const getCourseName = (report) => {
    if (!report) return '-';
    return report.course_name || report.course || '-';
  };

  // Format date for API request
  // const formatDateParam = (date) => date ? new Date(date).toISOString().slice(0, 10) : '';

  // Format date for display
  const formatDate = (dateString) => {
    if (!dateString) return '-';
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric', 
      month: 'long', 
      day: 'numeric', 
      hour: '2-digit', 
      minute: '2-digit'
    });
  };

  // Search for reports
  const handleSearch = async (e) => {
    if (e) e.preventDefault();
    // Alert if no filter is applied
    if (!isAnyFilterApplied()) {
      alert('Please enter at least one filter before searching.');
      return;
    }
    setLoading(true);
    setError(null);

    try {
      // Fetch pending reports
      const pendingResponse = await fetch(`${apiUrl}/api/get-all-report-pdfs`);
      if (!pendingResponse.ok) throw new Error('Failed to fetch pending reports');
      const pendingReports = await pendingResponse.json();

      // Fetch approved/rejected reports
      const statsResponse = await fetch(`${apiUrl}/api/report-stats`);
      if (!statsResponse.ok) throw new Error('Failed to fetch approved/rejected reports');
      const statsReports = await statsResponse.json();

      // Merge both
      let allReports = [...pendingReports, ...statsReports];

      // Remove duplicates (by id or registration_id)
      const uniqueIds = new Set();
      allReports = allReports.filter(report => {
        const id = report.id || report.registration_id;
        if (uniqueIds.has(id)) return false;
        uniqueIds.add(id);
        return true;
      });

      // Fix: toDate should include the whole day
      const toDateObj = toDate ? new Date(toDate + 'T23:59:59.999') : null;

      // 2. Client-side filtering
      const filteredReports = allReports.filter(report =>
        report.teacher_username === user.username &&
        (!studentName ||
          ((report.name && report.name.toLowerCase().includes(studentName.toLowerCase())) ||
           (report.username && report.username.toLowerCase().includes(studentName.toLowerCase())))
        ) &&
        (!username || (report.username) === username) &&
        (!courseName || (report.course_name && report.course_name.toLowerCase().includes(courseName.toLowerCase()))) &&
        (!selectedYear || String(report.student_academic_year) === String(selectedYear)) &&
        (!status || report.status === status) &&
        (!fromDate || new Date(report.reported_at) >= new Date(fromDate)) &&
        (!toDate || new Date(report.reported_at) <= toDateObj)
      );

      setReports(filteredReports);
      if (filteredReports.length === 0) {
        setError('No reports found for the selected filters');
      }
    } catch (err) {
      setError(err.message || 'Failed to fetch reports. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  // Toggle PDF view
  const toggleViewReport = async (report) => {
    if (selectedPdf === report.id) {
      setSelectedPdf(null);
      return;
    }
    
    setSelectedPdf(report.id);
    if (pdfUrls[report.id]) return;

    setLoadingPdf(true);
    
    try {
      const response = await fetch(`${apiUrl}/api/reports/${report.registration_id}/pdf`);
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      
      setPdfUrls(prev => ({
        ...prev,
        [report.id]: url
      }));
    } catch (err) {
      console.error('Error loading PDF:', err);
      alert('Failed to load report PDF.');
    } finally {
      setLoadingPdf(false);
    }
  };

  // Calculate status counts
  const statusCounts = {
    pending: reports.filter(r => r.status === 'pending').length,
    approved: reports.filter(r => r.status === 'approved').length,
    rejected: reports.filter(r => r.status === 'rejected').length
  };

  // Helper to check if any filter is applied
  const isAnyFilterApplied = () => {
    return (
      studentName ||
      username ||
      courseName ||
      selectedYear ||
      status ||
      fromDate ||
      toDate
    );
  };

  // Handle keyboard navigation for name suggestions
  const handleNameKeyDown = (e) => {
    if (!showNameSuggestions || nameSuggestions.length === 0) return;
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      setNameSuggestionIndex((prev) => (prev + 1) % nameSuggestions.length);
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      setNameSuggestionIndex((prev) => (prev - 1 + nameSuggestions.length) % nameSuggestions.length);
    } else if (e.key === 'Enter') {
      if (nameSuggestionIndex >= 0 && nameSuggestionIndex < nameSuggestions.length) {
        handleSelectStudent(nameSuggestions[nameSuggestionIndex], 'name');
        setNameSuggestionIndex(-1);
      }
    } else if (e.key === 'Escape') {
      setShowNameSuggestions(false);
      setNameSuggestionIndex(-1);
    }
  };

  // Handle keyboard navigation for username suggestions
  const handleUsernameKeyDown = (e) => {
    if (!showUsernameSuggestions || usernameSuggestions.length === 0) return;
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      setUsernameSuggestionIndex((prev) => (prev + 1) % usernameSuggestions.length);
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      setUsernameSuggestionIndex((prev) => (prev - 1 + usernameSuggestions.length) % usernameSuggestions.length);
    } else if (e.key === 'Enter') {
      if (usernameSuggestionIndex >= 0 && usernameSuggestionIndex < usernameSuggestions.length) {
        handleSelectStudent(usernameSuggestions[usernameSuggestionIndex], 'username');
        setUsernameSuggestionIndex(-1);
      }
    } else if (e.key === 'Escape') {
      setShowUsernameSuggestions(false);
      setUsernameSuggestionIndex(-1);
    }
  };

  // Handle keyboard navigation for course suggestions
  const handleCourseKeyDown = (e) => {
    if (!showCourseSuggestions || courseSuggestions.length === 0) {
      if (e.key === 'Enter') {
        e.target.form && e.target.form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      }
      return;
    }
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      setCourseSuggestionIndex((prev) => (prev + 1) % courseSuggestions.length);
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      setCourseSuggestionIndex((prev) => (prev - 1 + courseSuggestions.length) % courseSuggestions.length);
    } else if (e.key === 'Enter') {
      if (courseSuggestionIndex >= 0 && courseSuggestionIndex < courseSuggestions.length) {
        handleSelectCourse(courseSuggestions[courseSuggestionIndex]);
        setCourseSuggestionIndex(-1);
      }
    } else if (e.key === 'Escape') {
      setShowCourseSuggestions(false);
      setCourseSuggestionIndex(-1);
    }
  };

  // Helper to fetch quiz score for a registrationId
  const fetchQuizScore = async (registrationId) => {
    if (!registrationId || quizScores[registrationId]?.loading || quizScores[registrationId]?.percentage !== undefined) return;
    setQuizScores(prev => ({ ...prev, [registrationId]: { loading: true } }));
    try {
      const res = await axios.get(`${apiUrl}/api/quiz-scores/${registrationId}`);
      // If multiple scores, take the latest (first, as per backend order)
      const percentage = Array.isArray(res.data) && res.data.length > 0 ? res.data[0].percentage : undefined;
      setQuizScores(prev => ({ ...prev, [registrationId]: { loading: false, percentage } }));
    } catch (err) {
      setQuizScores(prev => ({ ...prev, [registrationId]: { loading: false, percentage: undefined } }));
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-50 py-8 px-4">
      <div className="max-w-6xl mx-auto">
        {/* Search Section */}
        <div className="bg-white rounded-3xl shadow-lg mb-8 p-8">
          <h2 className="text-2xl font-bold text-gray-700 mb-6">Student Reports</h2>
          <div className="border-b mb-6" />
          <form onSubmit={handleSearch}>
            <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-6">
              <div>
                <label className="block text-sm font-semibold text-gray-600 mb-2">Student Name</label>
                <div className="relative">
                  <input
                    type="text"
                    placeholder="Type for hints..."
                    value={studentName}
                    onChange={(e) => { setStudentName(e.target.value); setNameSuggestionIndex(-1); }}
                    onFocus={() => setShowNameSuggestions(true)}
                    onBlur={() => setTimeout(() => setShowNameSuggestions(false), 150)}
                    onKeyDown={handleNameKeyDown}
                    className="w-full p-3 rounded-lg border border-gray-200 focus:ring-2 focus:ring-blue-200 focus:border-blue-400 text-gray-700 bg-gray-50"
                  />
                  {showNameSuggestions && nameSuggestions.length > 0 && (
                    <ul className="absolute z-10 left-0 right-0 bg-white border border-gray-200 rounded-lg mt-1 max-h-48 overflow-y-auto shadow-lg">
                      {nameSuggestions.map((student, idx) => (
                        <li
                          key={student.id || student.username}
                          className={`px-4 py-2 cursor-pointer hover:bg-blue-50 ${idx === nameSuggestionIndex ? 'bg-blue-100' : ''}`}
                          onMouseDown={() => handleSelectStudent(student, 'name')}
                        >
                          <span className="font-medium text-gray-800">{student.name}</span>
                          <span className="text-gray-500 ml-2 text-xs">@{student.username}</span>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
              <div>
                <label className="block text-sm font-semibold text-gray-600 mb-2">Username</label>
                <div className="relative">
                  <input
                    type="text"
                    placeholder="Type for hints..."
                    value={username}
                    onChange={(e) => { setUsername(e.target.value); setUsernameSuggestionIndex(-1); }}
                    onFocus={() => setShowUsernameSuggestions(true)}
                    onBlur={() => setTimeout(() => setShowUsernameSuggestions(false), 150)}
                    onKeyDown={handleUsernameKeyDown}
                    className="w-full p-3 rounded-lg border border-gray-200 focus:ring-2 focus:ring-blue-200 focus:border-blue-400 text-gray-700 bg-gray-50"
                  />
                  {showUsernameSuggestions && usernameSuggestions.length > 0 && (
                    <ul className="absolute z-10 left-0 right-0 bg-white border border-gray-200 rounded-lg mt-1 max-h-48 overflow-y-auto shadow-lg">
                      {usernameSuggestions.map((student, idx) => (
                        <li
                          key={student.id || student.username}
                          className={`px-4 py-2 cursor-pointer hover:bg-blue-50 ${idx === usernameSuggestionIndex ? 'bg-blue-100' : ''}`}
                          onMouseDown={() => handleSelectStudent(student, 'username')}
                        >
                          <span className="font-medium text-gray-500">@{student.username}</span>
                          <span className="text-gray-800 ml-2">{student.name}</span>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
              <div>
                <label className="block text-sm font-semibold text-gray-600 mb-2">Course Name</label>
                <div className="relative">
                  <input
                    type="text"
                    placeholder="Type for hints..."
                    value={courseName}
                    onChange={(e) => { setCourseName(e.target.value); setCourseSuggestionIndex(-1); }}
                    onFocus={() => setShowCourseSuggestions(true)}
                    onBlur={() => setTimeout(() => setShowCourseSuggestions(false), 150)}
                    onKeyDown={handleCourseKeyDown}
                    className="w-full p-3 rounded-lg border border-gray-200 focus:ring-2 focus:ring-blue-200 focus:border-blue-400 text-gray-700 bg-gray-50"
                  />
                  {showCourseSuggestions && courseSuggestions.length > 0 && (
                    <ul className="absolute z-10 left-0 right-0 bg-white border border-gray-200 rounded-lg mt-1 max-h-48 overflow-y-auto shadow-lg">
                      {courseSuggestions.map((course, idx) => (
                        <li
                          key={idx}
                          className={`px-4 py-2 cursor-pointer hover:bg-blue-50 ${idx === courseSuggestionIndex ? 'bg-blue-100' : ''}`}
                          onMouseDown={() => handleSelectCourse(course)}
                        >
                          <span className="font-medium text-gray-800">{course}</span>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
              <div>
                <label className="block text-sm font-semibold text-gray-600 mb-2">Year</label>
                <select
                  value={selectedYear}
                  onChange={(e) => setSelectedYear(e.target.value)}
                  className="w-full p-3 rounded-lg border border-gray-200 focus:ring-2 focus:ring-blue-200 focus:border-blue-400 text-gray-700 bg-gray-50 appearance-none"
                >
                  <option value="">-- Select --</option>
                  {YEARS.map(year => (
                    <option key={year.id} value={year.id}>{year.name}</option>
                  ))}
                </select>
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
              <div>
                <label className="block text-sm font-semibold text-gray-600 mb-2">Status</label>
                <select
                  value={status}
                  onChange={(e) => setStatus(e.target.value)}
                  className="w-full p-3 rounded-lg border border-gray-200 focus:ring-2 focus:ring-blue-200 focus:border-blue-400 text-gray-700 bg-gray-50 appearance-none"
                >
                  <option value="">-- Select --</option>
                  <option value="pending">Pending</option>
                  <option value="approved">Approved</option>
                  <option value="rejected">Rejected</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-semibold text-gray-600 mb-2">From Date</label>
                <input
                  type="date"
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                  className="w-full p-3 rounded-lg border border-gray-200 focus:ring-2 focus:ring-blue-200 focus:border-blue-400 text-gray-700 bg-gray-50"
                />
              </div>
              <div>
                <label className="block text-sm font-semibold text-gray-600 mb-2">To Date</label>
                <input
                  type="date"
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                  className="w-full p-3 rounded-lg border border-gray-200 focus:ring-2 focus:ring-blue-200 focus:border-blue-400 text-gray-700 bg-gray-50"
                />
              </div>
            </div>
            <div className="flex justify-end gap-4">
              <button
                type="button"
                onClick={handleReset}
                className="px-8 py-2 border-2 border-purple-500 text-purple-600 rounded-full font-semibold bg-white hover:bg-purple-50 transition"
              >
                Reset
              </button>
              <button
                type="submit"
                className="px-8 py-2 bg-purple-600 text-white rounded-full font-semibold hover:bg-purple-700 transition"
              >
                Search
              </button>
            </div>
          </form>
        </div>

        {/* Results Section */}
        {loading ? (
          <div className="flex justify-center py-12">
            <FaSpinner className="animate-spin text-4xl text-blue-600" />
          </div>
        ) : error && isAnyFilterApplied() ? (
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-6">
            <strong>Error:</strong> {error}
          </div>
        ) : reports.length > 0 ? (
          <div className="overflow-x-auto bg-white rounded-xl shadow-sm p-4">
            <div className="mb-4 flex flex-wrap gap-4 items-center">
              <div className="px-4 py-2 rounded-lg bg-yellow-100 text-yellow-800 font-semibold text-sm">
                Pending: {statusCounts.pending}
              </div>
              <div className="px-4 py-2 rounded-lg bg-green-100 text-green-800 font-semibold text-sm">
                Approved: {statusCounts.approved}
              </div>
              <div className="px-4 py-2 rounded-lg bg-red-100 text-red-800 font-semibold text-sm">
                Rejected: {statusCounts.rejected}
              </div>
            </div>
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600">S.No.</th>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600">Student Name</th>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600">Username</th>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600">Course Name</th>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600">Year</th>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600">Score</th>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600">Status</th>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600">Date</th>
                  <th className="px-4 py-3 text-center text-xs font-semibold text-gray-600">Actions</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-100">
                {reports.map((report, idx) => (
                  <React.Fragment key={report.id || idx}>
                    <tr className="hover:bg-blue-50 transition">
                      <td className="px-4 py-3 text-sm text-gray-700">{idx + 1}</td>
                      <td className="px-4 py-3 text-sm text-gray-900 font-medium">
                        {report.name || report.username || 'Not specified'}
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700">{report.username}</td>
                      <td className="px-4 py-3 text-sm text-gray-700">{getCourseName(report)}</td>
                      <td className="px-4 py-3 text-sm text-gray-700">{report.student_academic_year || '-'}</td>
                      <td className="px-4 py-3 text-sm text-gray-700">
                        {(() => {
                          const regId = report.registration_id;
                          if (!regId) return '-';
                          if (!quizScores[regId]) fetchQuizScore(regId);
                          const scoreObj = quizScores[regId];
                          if (!scoreObj || scoreObj.loading) return <FaSpinner className="animate-spin text-blue-500 inline-block" />;
                          if (scoreObj.percentage === undefined || scoreObj.percentage === null) return '-';
                          
                          // Color coding based on percentage ranges
                          let bgColor, textColor;
                          if (scoreObj.percentage >= 80) {
                            bgColor = 'bg-green-100';
                            textColor = 'text-green-700';
                          } else if (scoreObj.percentage >= 60) {
                            bgColor = 'bg-yellow-100';
                            textColor = 'text-yellow-700';
                          } else {
                            bgColor = 'bg-red-100';
                            textColor = 'text-red-700';
                          }
                          
                          return (
                            <span className={`px-2 py-1 rounded-full text-xs font-semibold ${bgColor} ${textColor}`}>
                              {scoreObj.percentage}%
                            </span>
                          );
                        })()}
                      </td>
                      <td className="px-4 py-3 text-sm">
                        <span className={`px-2 py-1 rounded-full text-xs font-semibold ${
                          report.status === 'approved' ? 'bg-green-100 text-green-700' :
                          report.status === 'pending' ? 'bg-yellow-100 text-yellow-700' :
                          report.status === 'rejected' ? 'bg-red-100 text-red-700' :
                          'bg-gray-100 text-gray-700'
                        }`}>
                          {report.status ? report.status.charAt(0).toUpperCase() + report.status.slice(1) : '-'}
                        </span>
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700">{formatDate(report.reported_at)}</td>
                      <td className="px-4 py-3 text-center flex gap-2 justify-center">
                        <button
                          onClick={() => toggleViewReport(report)}
                          className="py-1 px-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors flex items-center gap-1 text-xs"
                        >
                          {selectedPdf === report.id ? <FaEyeSlash /> : <FaEye />}
                          {selectedPdf === report.id ? 'Hide' : 'View'}
                        </button>
                        {pdfUrls[report.id] && (
                          <a
                            href={pdfUrls[report.id]}
                            download={`report_${report.username}_${report.id}.pdf`}
                            className="py-1 px-3 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors flex items-center gap-1 text-xs"
                          >
                            <FaDownload />
                            Download
                          </a>
                        )}
                      </td>
                    </tr>
                    {selectedPdf === report.id && (
                      <tr>
                        <td colSpan={9} className="bg-gray-50 px-4 py-4">
                          {loadingPdf ? (
                            <div className="flex justify-center py-12">
                              <FaSpinner className="animate-spin text-4xl text-blue-600" />
                            </div>
                          ) : (
                            pdfUrls[report.id] && (
                              <iframe
                                src={pdfUrls[report.id]}
                                className="w-full h-[500px] border rounded-lg"
                                title={`PDF Report ${report.id}`}
                              />
                            )
                          )}
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default TeacherReport;